import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Megaphone, MessageSquare, Settings, LogOut, ExternalLink } from "lucide-react";
import { adminApi } from "../../lib/api";
import { AnnouncementsManager } from "../../components/admin/AnnouncementsManager";
import { MessagesManager } from "../../components/admin/MessagesManager";
import { SettingsManager } from "../../components/admin/SettingsManager";

const TABS = [
  { id: "duyurular", label: "Haber & Duyurular", icon: Megaphone },
  { id: "mesajlar", label: "Gelen Mesajlar", icon: MessageSquare },
  { id: "ayarlar", label: "Ayarlar", icon: Settings },
];

export default function AdminPanel() {
  const [admin, setAdmin] = useState(null);
  const [tab, setTab] = useState("duyurular");
  const nav = useNavigate();

  useEffect(() => {
    adminApi.get("/admin/me").then((r) => setAdmin(r.data)).catch(() => {
      localStorage.removeItem("bsk_admin_token");
      nav("/yonetim/giris", { replace: true });
    });
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("bsk_admin_token");
    nav("/yonetim/giris");
  };

  if (!admin) return <div className="min-h-screen flex items-center justify-center text-slate-500">Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="bg-[#1B4332] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 font-display font-bold text-lg"><img src="/logo.jpg" alt="" className="w-10 h-10 rounded-full object-cover" /> Yönetim Paneli</div>
          <div className="flex items-center gap-2 text-sm">
            <span className="hidden sm:inline text-[#D8F3DC]" data-testid="admin-email">{admin.email}</span>
            <Link to="/" target="_blank" className="p-2 rounded-full hover:bg-white/10" title="Siteyi gör" data-testid="admin-view-site"><ExternalLink size={18} /></Link>
            <button onClick={logout} className="flex items-center gap-1 px-3 py-2 rounded-full bg-white/10 hover:bg-white/20 font-semibold" data-testid="admin-logout-btn"><LogOut size={16} /> Çıkış</button>
          </div>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex gap-2 overflow-x-auto pb-2" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)} data-testid={`admin-tab-${t.id}`}
              className={`flex items-center gap-2 px-5 py-3 rounded-full font-bold text-sm whitespace-nowrap transition-colors ${tab === t.id ? "bg-[#1B4332] text-white" : "bg-white border border-black/10 text-slate-600 hover:bg-[#D8F3DC]"}`}>
              <t.icon size={18} /> {t.label}
            </button>
          ))}
        </div>
        <div className="mt-6">
          {tab === "duyurular" && <AnnouncementsManager />}
          {tab === "mesajlar" && <MessagesManager />}
          {tab === "ayarlar" && <SettingsManager />}
        </div>
      </div>
    </div>
  );
}
